

define(function (require) {
    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var HtmlSanitizerUtils = require('HtmlSanitizerUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var logger = WebAgentLogger.getLogger('WebAgentUtils');
    var _ = require('underscore');

    var DATA_SOURCES = {
        HISTORY: 'history',
        STREAM: 'ums'
    };

    var DEFAULTS = {
        DATA_RETENTION: 14
    };

    /**
     * Returns clean engagementId with no sequence number
     * e.g. le12345678-1 ==> le12345678
     *
     * @param {String} engagementId
     * @param {String|Number} engagementSequence
     * @returns {String}
     */
    function extractRtEngagementId(engagementId, engagementSequence) {
        if (!_.isUndefined(engagementSequence) &&
            _.isString(engagementId) &&
            engagementId.lastIndexOf("-" + engagementSequence) === engagementId.length - 2) {

            return engagementId.slice(0, engagementId.length - String(engagementSequence).length - 1);
        }
        return engagementId;
    }

    /**
     * Sanitize given text to remove HTML and JS notations
     *
     * @param {String} text
     */
    function sanitizeText(text) {

        var _logger = this.logger || logger;

        var result = HtmlSanitizerUtils.sanitizeHtml(text);
        result.cleanText = _reTargetElements(result.cleanText);
        return {
            sanitized: result.sanitized,
            text: result.cleanText
        };

        function _reTargetElements(text) {
            var elements, el, modified, targetAttrValue,
                div = document.createElement("DIV"),
                targetElementTagNames = ["A", "FORM"];

            div.innerHTML = text;
            for (var i = 0; i < targetElementTagNames.length; i++) {
                elements = div.getElementsByTagName(targetElementTagNames[i]);
                for (var j = 0; j < elements.length; j++) {
                    try {
                        el = elements[j];
                        targetAttrValue = el.getAttribute("target");
                        if (!targetAttrValue || targetAttrValue.toLowerCase() !== "_blank") {
                            modified = true;
                            el.setAttribute("target", "_blank");
                        }
                    } catch (exc) {
                        _logger.error("Error when trying to reTargetLinks elements, result HTML: " + div.innerHTML + " text: " + text, "reTargetElements");
                    }
                }
                elements = null;
            }

            if (modified) {
                return div.innerHTML;
            } else {
                return text;
            }
        }
    }

    /**
     * Extract text from idnv input
     *
     * @param {String} chatLineText
     */
    function removeIdnvSpansFromChatLine(chatLineText) {
        if (typeof chatLineText === "undefined" || chatLineText === null) {
            return '';
        } else {
            chatLineText += '';
        }
        if (chatLineText.match( /data-lp-collab-type\s*=\s*["|']idnv_answer["|']/)) {
            var domElement = document.createElement('div');
            domElement.innerHTML = this.sanitizeText(chatLineText).text;
            return domElement.textContent;
        }
        return chatLineText;
    }

    /**
     * Return configured data retention time in days
     */
    function getDataRetentionTime() {
        return agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.dataRetentionInDays') || DEFAULTS.DATA_RETENTION;
    }

    /**
     * returns true if the url param matches the security check, false otherwise
     * @param {*} url
     */
    function isSecureUrl(url) {
        if (!url || typeof url !== 'string') {
            return false;
        }
        var secureUrlPattern = /^(https:\/\/)[A-z0-9]+([\-\.]{1}[A-z0-9]+)*\.[A-z]*(:[0-9]*)?(\/.*)?$/;
        return secureUrlPattern.test(url);
    }

    return {
        isSecureUrl: isSecureUrl,
        extractRtEngagementId: extractRtEngagementId,
        sanitizeText: sanitizeText,
        removeIdnvSpansFromChatLine: removeIdnvSpansFromChatLine,
        getDataRetentionTime: getDataRetentionTime,
        DATA_SOURCES: DATA_SOURCES
    };

});
